import { useOutletContext } from "react-router";

import { ClaimActionButtons, ClaimSelectionProvider, ClientTabBase, ClaimListTab as SharedClaimListTab } from "@shared";

import { ClientDetailResponse } from "@/api";
import { ClientStatusWidget } from "@/pages/clients/client/components/client-status-widget/ClientStatusWidget";

// Internal-app chrome around the shared claims list: the ClientTabBase hosts the action buttons in
// its tab-actions row, while the portal renders the shared list with its own tab-actions row. The
// selection provider spans both slots, and only this app mounts it — selecting claims serves the
// staff-only bulk actions.
export function ClaimListTab() {
  const client = useOutletContext<ClientDetailResponse>();

  return (
    <ClaimSelectionProvider>
      <ClientTabBase
        tabActions={<ClaimActionButtons clientId={client.clientId} />}
        navigation={<></>}
        navigationFooter={<ClientStatusWidget client={client} />}
      >
        <SharedClaimListTab />
      </ClientTabBase>
    </ClaimSelectionProvider>
  );
}
